import { Stack, styled } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { useDebounceCallback, useResizeObserver } from "usehooks-ts";

import type { CMSChipListDTO } from "~/CMSComponents/dto";
import { CMSChipLink } from "../CMSChipLink/CMSChipLink";

interface Props extends Omit<CMSChipListDTO, "type"> {
  className?: string;
}

export const CMSChipList = (props: Props) => {
  const { className } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const stackRef = useRef<HTMLDivElement>(null);
  const [centered, setCentered] = useState(false);

  const updateStyle = useCallback(() => {
    if (stackRef.current && containerRef.current) {
      const stackWidth = stackRef.current.offsetWidth;
      const containerWidth = containerRef.current.offsetWidth;
      setCentered(stackWidth < containerWidth);
    }
  }, []);

  const debouncedUpdateStyle = useDebounceCallback(updateStyle, 200);

  useResizeObserver({
    ref: containerRef,
    onResize: debouncedUpdateStyle,
  });

  return (
    <Container className={className} ref={containerRef} centered={centered}>
      <Stack direction={"row"} gap={2} ref={stackRef}>
        {props.chipsComponent.map((dto, index) => (
          <CMSChipLink key={index} {...dto} variant="assist" />
        ))}
      </Stack>
    </Container>
  );
};

const Container = styled("div", { shouldForwardProp: (prop) => prop !== "centered" })<{ centered: boolean }>(
  ({ centered }) => ({
    overflowX: "auto",
    scrollbarWidth: "none",
    display: "flex",
    justifyContent: centered ? "center" : "flex-start",
    marginBottom: "-40px", // SCHAEFF-37473
  }),
);
